import { useRefinementList } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { DropCards } from '@sorare/core/src/atoms/icons/DropCards';
import { useTransitionApi } from '@sorare/core/src/hooks/ui/useTransitionApi';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled.div`
  position: fixed;
  bottom: 140px;
  right: var(--double-unit);
  @media ${laptopAndAbove} {
    bottom: var(--quadruple-unit);
    right: var(--quadruple-unit);
  }
  min-width: 200px;
`;
type Props = {
  selectingCardsToDrop: boolean;
  setSelectingCardsToDrop: (value: boolean) => void;
  rarity?: Rarity;
};

export const DropCardsButton = ({
  selectingCardsToDrop,
  setSelectingCardsToDrop,
  rarity,
}: Props) => {
  const {
    flags: { enableProF2P = false },
  } = useFeatureFlags();
  const { updateDOM } = useTransitionApi();
  const { items } = useRefinementList({
    attribute: FILTERS.rarity.attribute,
  });
  const refinedItems = items.filter(item => item.isRefined);

  const selectedRarity =
    rarity ?? (refinedItems.length === 1 ? refinedItems[0].value : undefined);

  if (selectedRarity !== Rarity.common) {
    return null;
  }
  return (
    enableProF2P &&
    !selectingCardsToDrop && (
      <Wrapper>
        <Button
          fullWidth
          color="secondary"
          size="medium"
          startIcon={<DropCards />}
          onClick={() => {
            updateDOM(() => {
              setSelectingCardsToDrop(true);
            });
          }}
        >
          <FormattedMessage
            id="MyCards.dropCards"
            defaultMessage="Drop Cards"
          />
        </Button>
      </Wrapper>
    )
  );
};
